import { mergeStyleSets } from 'office-ui-fabric-react';

export const classNames = mergeStyleSets({
  exampleRoot: {
    marginTop: "20px",
    marginLeft: "20px",
    marginRight: "20px",
  },
  nameText: {
    fontWeight: "bold",
  },
});

export const messageBarStyle = () => {
  const _style = {
    marginTop: "1px",
    borderBottom: "1px solid blue",
    borderTop: "1px solid blue",
  };
  return _style;
};

export const messageBodyStyle = () => {
  const _style = {
    backgroundColor: "#f3f2f1",
    color: "black",
    marginLeft: "100px",
    marginRight: "20px",
    marginTop: "5px",
    marginBottom: "5px",
    lineHeight: "18pt",
  };
  return _style;
};
